import React, { useState } from 'react';
import { useExchangeRates } from '../hooks/useExchangeRates';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
  addTransaction,
  deleteTransaction,
  clearTransactions,
} from '../features/currency/currencySlice';

const CurrencyConverter: React.FC = () => {
  const [amount, setAmount] = useState(1);
  const [from, setFrom] = useState('USD');
  const [to, setTo] = useState('EUR');

  const dispatch = useAppDispatch();
  const transactions = useAppSelector((state) => state.currency.transactions);

  const { data: conversion_rates, isLoading, error } = useExchangeRates(from);
  const converted = conversion_rates ? amount * conversion_rates[to] : 0;
  const currencies = conversion_rates ? Object.keys(conversion_rates) : [];

  const handleConvert = () => {
    if (conversion_rates && from !== to) {
      dispatch(
        addTransaction({
          amount,
          from,
          to,
          result: parseFloat(converted.toFixed(2)),
        })
      );
    }
  };

  return (
    <div
      style={{
        maxWidth: 500,
        margin: '40px auto',
        padding: 30,
        borderRadius: 12,
        backgroundColor: '#f9f9f9',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h2 style={{ textAlign: 'center', marginBottom: 20 }}>Start Converting</h2>

      <input
        type="number"
        value={amount}
        onChange={(e) => setAmount(parseFloat(e.target.value))}
        style={{
          marginBottom: 15,
          width: '100%',
          padding: '10px',
          fontSize: '1rem',
          borderRadius: 6,
          border: '1px solid #ccc',
        }}
      />

      <div style={{ display: 'flex', gap: 10, marginBottom: 15 }}>
        <select
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          style={{
            flex: 1,
            padding: 10,
            borderRadius: 6,
            border: '1px solid #ccc',
            fontSize: '1rem',
          }}
        >
          {currencies.map((cur) => (
            <option key={cur} value={cur}>
              {cur}
            </option>
          ))}
        </select>

        <span style={{ alignSelf: 'center' }}>→</span>

        <select
          value={to}
          onChange={(e) => setTo(e.target.value)}
          style={{
            flex: 1,
            padding: 10,
            borderRadius: 6,
            border: '1px solid #ccc',
            fontSize: '1rem',
          }}
        >
          {currencies.map((cur) => (
            <option key={cur} value={cur}>
              {cur}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={handleConvert}
        disabled={from === to}
        style={{
          width: '100%',
          padding: 12,
          fontSize: '1rem',
          backgroundColor: from === to ? '#ccc' : '#007BFF',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: from === to ? 'not-allowed' : 'pointer',
          marginBottom: 20,
        }}
      >
        Convert
      </button>

      {!isLoading && !error && (
        <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: 20 }}>
          {amount} {from} = <strong>{converted.toFixed(2)}</strong> {to}
        </p>
      )}

      <h3 style={{ marginTop: 30, marginBottom: 10 }}>Transaction History</h3>

      {transactions.length > 0 && (
        <button
          onClick={() => dispatch(clearTransactions())}
          style={{
            marginBottom: 10,
            background: 'red',
            color: '#fff',
            border: 'none',
            padding: '8px 12px',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          Clear All
        </button>
      )}

      <ul style={{ listStyle: 'none', padding: 0 }}>
        {transactions.map((t) => (
          <li
            key={t.id}
            style={{
              padding: '10px 15px',
              backgroundColor: '#fff',
              borderRadius: 6,
              marginBottom: 10,
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
            }}
          >
            {t.date.split('T')[0]} — {t.amount} {t.from} → {t.result} {t.to}

            <button
                onClick={() => dispatch(deleteTransaction(t.id))}
                style={{
                 background: '#dc3545',
                 border: 'none',
                 color: '#fff',
                borderRadius: 4,
                padding: '4px 8px',
                cursor: 'pointer',
                fontSize: '0.8rem',
        }}
      >
              Delete
              </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CurrencyConverter;
